import { FinalSalary } from "./finalSalary";
import { PensionPot } from "./pensionPot";
import { Saving } from "./saving";
import { Scenario } from "./scenario";
import { OtherCash } from "./otherCash";
import { OtherIncome } from "./otherIncome";
import ScenarioOutcome from "./scenarioOutcome";
import ScenarioType from "./scenarioType";
import EditMode from "./editMode";
import dateTimeProvider from "./systemDateTimeProvider";

export default class ObjectBuilder {
  public static createPensionPot(
    id: number,
    name: string,
    currentValue: number,
    estimatedValueAtPresent: number,
    estimatedValueAtRetirement: number,
    lumpSumValueAtRetirement: number,
    isPayingContributionsToTgtRetDate: boolean,
    personalMonthlyContribution: number,
    employerMonthlyContribution: number,
    willTheseIncreaseIfSalaryIncreases: boolean,
    userCanEditCurrentValue: boolean,
    userCanEditContribution: boolean
  ): PensionPot {
    return {
      id: id,
      name: name,
      valuationAmount: currentValue,
      valuationDate: dateTimeProvider.now().toISOString(),
      estimatedValueAtPresent,
      estimatedValueAtRetirement: estimatedValueAtRetirement,
      lumpSumValueAtRetirement,
      isPayingContributionsToTgtRetDate: isPayingContributionsToTgtRetDate,
      personalMonthlyContribution: personalMonthlyContribution,
      employerMonthlyContribution: employerMonthlyContribution,
      monthlyContribution: personalMonthlyContribution + employerMonthlyContribution,
      willTheseIncreaseIfSalaryIncreases: willTheseIncreaseIfSalaryIncreases,
      userCanEditCurrentValue: userCanEditCurrentValue,
      userCanEditContribution: userCanEditContribution
    } as PensionPot;
  }

  public static createFinalSalary(
    id: number,
    name: string,
    startingIncome: number,
    payableFromMonth: number,
    payableFromYear: number,
    inflation: string
  ): FinalSalary {
    return {
      id: id,
      name: name,
      startingIncome: startingIncome,
      payableFromMonth: payableFromMonth,
      payableFromYear: payableFromYear,
      inflation: inflation
    } as FinalSalary;
  }

  public static createSaving(
    id: number,
    name: string,
    currentValue: number,
    isStillPaying: boolean,
    monthlyPayment: number,
    willPaymentsIncrease: boolean
  ): Saving {
    return {
      id: id,
      name: name,
      currentValue: currentValue,
      isStillPaying: isStillPaying,
      monthlyPayment: monthlyPayment,
      willPaymentsIncrease: willPaymentsIncrease
    } as Saving;
  }

  public static createOtherCash(
    id: number,
    name: string,
    amount: number,
    payableFromMonth: number,
    payableFromYear: number
  ): OtherCash {
    return {
      id: id,
      name: name,
      amount: amount,
      payableFromMonth: payableFromMonth,
      payableFromYear: payableFromYear
    } as OtherCash;
  }

  public static createOtherIncome(
    id: number,
    name: string,
    amount: number,
    payableFromMonth: number,
    payableFromYear: number,
    payableToMonth: number,
    payableToYear: number,
    amountWillIncrease: boolean
  ): OtherIncome {
    return {
      id: id,
      editMode: EditMode.Write,
      name: name,
      amount: amount,
      payableFromMonth: payableFromMonth,
      payableFromYear: payableFromYear,
      payableToMonth: payableToMonth,
      payableToYear: payableToYear,
      amountWillIncrease: amountWillIncrease
    } as OtherIncome;
  }

  public static createScenario(
    scenarioType: ScenarioType,
    outcome: ScenarioOutcome
  ): Scenario {
    return {
      name: "",
      scenarioType: scenarioType,
      outcome: outcome
    } as Scenario;
  }
}
